var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.681 10.92h-.06V9.466C20.622 4.79 16.829 1 12.15 1c-4.68 0-8.473 3.79-8.473 8.465v1.456H3.32C2.012 10.92 1 12.079 1 13.416v3.713a2.347 2.347 0 0 0 2.32 2.406h2.2a.565.565 0 0 0 .535-.624v-7.277c0-.357-.208-.713-.535-.713h-.655V9.465a7.28 7.28 0 0 1 7.284-7.277 7.28 7.28 0 0 1 7.284 7.277v1.456h-.654c-.327 0-.536.356-.536.713v7.277a.564.564 0 0 0 .536.624h.683l-.06.089a4.698 4.698 0 0 1-3.775 1.871 2.943 2.943 0 0 0-5.827.564A2.972 2.972 0 0 0 12.773 25a3.063 3.063 0 0 0 2.14-.92c.381-.39.63-.889.714-1.427a5.888 5.888 0 0 0 4.727-2.346l.565-.832c1.278-.089 2.081-.89 2.081-2.05v-3.712c0-1.277-.951-2.792-2.319-2.792zM4.865 18.348H3.32a1.159 1.159 0 0 1-1.13-1.218v-3.713c0-.683.476-1.307 1.13-1.307h1.545v6.238zm9.187 4.9c-.33.358-.793.562-1.279.565a1.813 1.813 0 0 1-1.783-1.753 1.753 1.753 0 0 1 3.508 0c.024.441-.137.873-.446 1.189zm7.759-5.821c0 .802-.773.92-1.13.92h-1.248V12.11h1.248c.654 0 1.13.92 1.13 1.604v3.713z",
    fill: "#2B2B2B",
    fillRule: "nonzero",
    stroke: "#2B2B2B",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.8f0a3dfb4c10a56ea8ff1aaead72d1c8.svg";
export { ForwardRef as ReactComponent };